export const DASHBOARD_API_TOKEN_NAME: string = '___';
export const DASHBOARD_USER_TOKEN_NAME: string = '_____';
export const BOOKMARKS_PAGE_SIZE = 10;
export const ORDERS_PAGE_SIZE = 10;
export const SPECIALTY_OTHER_CODE = '22';
export const POSITION_OTHER_CODE = '11';
export const OTHER_HR_FUNCTION_CODE = '18';
export const OTHER_NON_HR_FUNCTION_CODE = '19';
export const LOGOUT_URL_END_PATH = '/system/sling/logout?resource=/content/shrm/saml_login';
export const LOGOUT_URL_DEV = 'https://dev-aem-www.shrm.org';
export const LOGOUT_URL_QA = 'https://qa-aem-www.shrm.org';
export const LOGOUT_URL_PROD = 'https://www.shrm.org';
export const qualificationsUrl = 'https://pmq.shrm.org/';
export const credentialsUrl =
  'https://www.shrm.org/LearningAndCareer/learning/Pages/Specialty-Credentials.aspx';
